import ShieldUserSvg from '@assets/images/svg/shield-user.svg';
import React from 'react';
import { View } from 'react-native';

export function ShieldUserIcon({ size = 24, color = '#333333' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ShieldUserSvg width={size} height={size} color={color} />
        </View>
    );
}



